import { useState } from 'react';
import { StepLayout } from '../components/StepLayout';
import { useAction, usePortal } from '../Portal';

export function FindOrder() {
  const { t, api, state, dispatch } = usePortal();
  const [email, setEmail] = useState(state.email);
  const [orderNumber, setOrderNumber] = useState('');
  const { busy, error, run } = useAction();

  const submit = () =>
    run(async () => {
      const trimmedEmail = email.trim();
      const result = await api.lookup({ email: trimmedEmail, orderNumber: orderNumber.trim() });
      if (result.next === 'otp') {
        dispatch({ type: 'OTP_REQUIRED', email: trimmedEmail, challenge: result.challenge, delivered: result.delivered });
        return;
      }
      api.setSession(result.session);
      dispatch({ type: 'ORDER_LOADED', view: result.view });
    });

  return (
    <StepLayout
      title={t('find.title')}
      error={error ?? state.notice}
      busy={busy}
      onNext={submit}
      nextLabel={t('find.submit')}
      nextDisabled={!email.trim() || !orderNumber.trim()}
    >
      <label className="nvd-claim-portal__field">
        <span className="nvd-claim-portal__label">{t('find.emailLabel')}</span>
        <input
          className="nvd-claim-portal__input"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder={t('find.emailPlaceholder')}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />
      </label>
      <label className="nvd-claim-portal__field">
        <span className="nvd-claim-portal__label">{t('find.orderLabel')}</span>
        <input
          className="nvd-claim-portal__input"
          autoComplete="off"
          maxLength={41}
          placeholder={t('find.orderPlaceholder')}
          value={orderNumber}
          onChange={(event) => setOrderNumber(event.target.value)}
          required
        />
        <span className="nvd-claim-portal__field-hint">{t('find.orderHint')}</span>
      </label>
      <p className="nvd-claim-portal__note">{t('find.existingHint')}</p>
    </StepLayout>
  );
}
